/**
 * Founders Circle Badge Component
 * Star with "FC" text overlay for the 50 Beta users who activated Hover accounts
 */

import React from 'react';
import { Star } from 'lucide-react';

interface FoundersCircleBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
}

export const FoundersCircleBadge: React.FC<FoundersCircleBadgeProps> = ({
  size = 'md',
  showTooltip = true
}) => {
  const sizeClasses = {
    sm: { container: 'w-5 h-5', star: 'w-5 h-5', text: 'text-[6px]' },
    md: { container: 'w-6 h-6', star: 'w-6 h-6', text: 'text-[7px]' },
    lg: { container: 'w-8 h-8', star: 'w-8 h-8', text: 'text-[9px]' }
  };

  const classes = sizeClasses[size];

  const badge = (
    <div
      className={`relative inline-flex items-center justify-center ${classes.container}`}
      title={showTooltip ? "Founders Circle - Lifetime Member" : undefined}
    >
      {/* Star background */}
      <Star
        className={`${classes.star} text-purple-400 absolute`}
        fill="currentColor"
        style={{
          filter: 'drop-shadow(0 0 3px rgba(147, 51, 234, 0.6))'
        }}
      />
      {/* FC text overlay */}
      <span
        className={`${classes.text} font-bold text-white relative z-10`}
        style={{
          textShadow: '0 0 2px rgba(0, 0, 0, 0.8)',
          letterSpacing: '-0.5px'
        }}
      >
        FC
      </span>
    </div>
  );

  return badge;
};
